<div class="main main-hid" *ngIf="validToken">
  <div class="row">
    <div id="bgimg" class="col-md-6"></div>
    <div class="col-md-6 col-xs-12">
      <div class="box-content">
        <div class="nav-login">
          <img src="./assets/img/tim-logo.svg" alt="Tim" title="Tim" />
        </div>
        <div class="form-content">
          <div class="form-main">
            <h1>{{ 'RESET_YOUR_PASSWORD' | translate }}</h1>

            <p class="top-label">{{ 'SIGNIN_DESC' | translate }}</p>
            <form [formGroup]="form" novalidate>
              <div class="form-group">
                <input
                  type="password"
                  class="form-control"
                  formControlName="password"
                  placeholder="{{ 'PASSWORD' | translate }}"
                  (keydown.space)="$event.preventDefault()"
                  maxlength="100"
                />
                <app-form-errors
                  [control]="form.controls['password']"
                  [messages]="errorMessages['password']"
                  [formSubmited]="formSubmited"
                ></app-form-errors>
              </div>

              <div class="form-group">
                <input
                  type="password"
                  class="form-control"
                  formControlName="passwordConfirmation"
                  placeholder="{{ 'PASSWORD_CONFIRMATION' | translate }}"
                  (keydown.space)="$event.preventDefault()"
                  maxlength="100"
                />

                <app-form-errors
                  [control]="form.controls['passwordConfirmation']"
                  [messages]="errorMessages['passwordConfirmation']"
                  [formSubmited]="formSubmited"
                ></app-form-errors>
              </div>

              <div class="alert alert-danger" *ngIf="formErrorMsg">{{ formErrorMsg }}</div>

              <button
                type="submit"
                class="btn btn-main"
                (click)="savePasswordRecovery()"
                [disabled]="sendingForm"
              >
                <span *ngIf="!sendingForm">{{ 'UPDATE_PASSWORD' | translate }}</span>
                <span *ngIf="sendingForm">{{ 'ONE_MOMENT_PLEASE' | translate }}...</span>
              </button>
            </form>

            <p class="bottom-label">
              {{ 'ALREADY_A_MEMBER' | translate }}
              <a routerLink="/ng/login">{{ 'LOGIN' | translate }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
